"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateChatRequestSchema = exports.SaveChatRequestSchema = exports.ChatListItemSchema = exports.ChatSchema = exports.SnapshotSchema = exports.ChatMetadataSchema = void 0;
const zod_1 = require("zod");
// Chat metadata (git integration, deploy targets)
exports.ChatMetadataSchema = zod_1.z.looseObject({
    gitUrl: zod_1.z.string().optional(),
    gitBranch: zod_1.z.string().optional(),
    netlifySiteId: zod_1.z.string().optional(),
});
// Snapshot — project file state at a point in the conversation
exports.SnapshotSchema = zod_1.z.object({
    chatIndex: zod_1.z.string(),
    files: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    summary: zod_1.z.string().optional(),
});
// Full chat record returned by the API
exports.ChatSchema = zod_1.z.object({
    id: zod_1.z.string(),
    urlId: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    messages: zod_1.z.array(zod_1.z.any()), // AI SDK Message[] — validated by the SDK, not us
    metadata: exports.ChatMetadataSchema.nullable(),
    snapshot: exports.SnapshotSchema.nullable(),
    projectId: zod_1.z.uuid().nullable().optional(),
    // Non-null while a generation for this chat is streaming (resumable streams).
    activeStreamId: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
// List item (no messages/snapshot — lightweight)
exports.ChatListItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    urlId: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    metadata: exports.ChatMetadataSchema.nullable(),
    projectId: zod_1.z.uuid().nullable().optional(),
    // Non-null while a generation for this chat is streaming (drives the badge).
    activeStreamId: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
// Create / full save
exports.SaveChatRequestSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    messages: zod_1.z.array(zod_1.z.any()),
    urlId: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    metadata: exports.ChatMetadataSchema.optional(),
    snapshot: exports.SnapshotSchema.optional(),
    projectId: zod_1.z.uuid().optional(),
});
// Partial update (description, metadata)
exports.UpdateChatRequestSchema = zod_1.z.object({
    description: zod_1.z.string().optional(),
    metadata: exports.ChatMetadataSchema.optional(),
});
